import { ActionTypes } from "../constantes/ActionTypes";

const initialState = {
  data: [],
  isLoading: false,
  error: "",
};

export const ShipmentDeleteReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case ActionTypes.ACTION_SHIPMENT_DELETE_START:
      return {
        ...state,
        isLoading: true,
      };
    case ActionTypes.ACTION_SHIPMENT_DELETE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: payload,
      };
    case ActionTypes.ACTION_SHIPMENT_DELETE_FAILED:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    default:
      return state;
  }
};
